(function () {

  'use strict';

  const selectors = {
    container: '.grjs-delivery-estimator',
    dateProduction: '.grjs-date-production',
    dateShipping: '.grjs-date-shipping',
    dateArrival: '.grjs-date-arrival',
    dateFinal: '.grjs-date-final',
    countdown: '.grjs-countdown-text',
    stickyDeliveryDate: '.grjs-sticky-delivery-date'
  };

  const container = document.querySelector(selectors.container);

  if (!container) return;

  const config = {
    shopNowStr: container.dataset.shopTime,
    productionDays: Number(container.dataset.productionDays),
    deliveryDays: Number(container.dataset.deliveryDays),
    cutoffHour: parseInt(container.dataset.cutoffHour, 10),
    cutoffMin: parseInt(container.dataset.cutoffMin, 10),
    workDays: container.dataset.workDays
      .split(',')
      .filter(s => s.trim() !== '')
      .map(Number),
    blockedDatesStr: container.dataset.holidays,
    textUntil: container.dataset.textUntil || 'Bestellen bis'
  };

  function formatIsoDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');

    return `${y}-${m}-${d}`;
  }

  function parseDateString(str, currentYear) {
    const parts = str.trim().split('.');

    if (parts.length < 2) return null;

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;

    let year = currentYear;

    if (parts.length === 3) {
      year = parseInt(parts[2], 10);
    }

    return new Date(year, month, day);
  }

  function getHolidaysList(str, baseDate) {
    if (!str) return [];

    const holidaySet = new Set();
    const currentYear = baseDate.getFullYear();
    const yearsToGenerate = [currentYear, currentYear + 1];

    const rawEntries = str
      .split(/,|;|\n|<br\s*\/?>/i)
      .map(s => s.trim())
      .filter(Boolean);

    yearsToGenerate.forEach(year => {
      rawEntries.forEach(entry => {
        if (entry.includes('-') && !entry.includes('None')) {
          const [startStr, endStr] = entry.split('-');

          const startDate = parseDateString(startStr, year);
          const endDate = parseDateString(endStr, year);

          if (startDate && endDate && startDate <= endDate) {
            let loopDate = new Date(startDate);

            while (loopDate <= endDate) {
              holidaySet.add(formatIsoDate(loopDate));
              loopDate.setDate(loopDate.getDate() + 1);
            }
          }
        } else {
          const d = parseDateString(entry, year);
          const isExplicitYear = entry.split('.').length === 3;

          if (d) {
            if (
              !isExplicitYear ||
              (isExplicitYear && d.getFullYear() === year)
            ) {
              holidaySet.add(formatIsoDate(d));
            }
          }
        }
      });
    });

    return Array.from(holidaySet);
  }

  function isWorkingDay(date, holidaysList) {
    const dayOfWeek = date.getDay();
    const isoDate = formatIsoDate(date);

    const isAllowedDay = config.workDays.includes(dayOfWeek);
    const isHoliday = holidaysList.includes(isoDate);

    return isAllowedDay && !isHoliday;
  }

  function getNextWorkingDay(date, holidaysList) {
    let result = new Date(date);
    let safety = 0;

    while (!isWorkingDay(result, holidaysList) && safety < 60) {
      result.setDate(result.getDate() + 1);
      safety++;
    }

    return result;
  }

  function addWorkingDays(startDate, daysToAdd, holidaysList) {
    let result = new Date(startDate);
    let added = 0;
    let safety = 0;

    while (added < daysToAdd && safety < 60) {
      result.setDate(result.getDate() + 1);

      if (isWorkingDay(result, holidaysList)) {
        added++;
      }

      safety++;
    }

    return result;
  }

  function calculateDates() {
    const now = new Date(config.shopNowStr);
    const holidays = getHolidaysList(config.blockedDatesStr, now);

    const cutoffDate = new Date(now);
    cutoffDate.setHours(config.cutoffHour, config.cutoffMin, 0, 0);

    const isAfterCutoff = now > cutoffDate;
    const isTodayWorking = isWorkingDay(now, holidays);

    let effectiveDate;

    if (isTodayWorking && !isAfterCutoff) {
      effectiveDate = new Date(now);
    } else {
      const tomorrow = new Date(now);

      tomorrow.setDate(tomorrow.getDate() + 1);

      effectiveDate = getNextWorkingDay(
        tomorrow,
        holidays
      );
    }

    const productionDate = addWorkingDays(
      effectiveDate,
      config.productionDays,
      holidays
    );

    const deliveryDate = new Date(productionDate);

    deliveryDate.setDate(
      deliveryDate.getDate() + config.deliveryDays
    );

    if (deliveryDate.getDay() === 0) {
      deliveryDate.setDate(
        deliveryDate.getDate() + 1
      );
    }

    return {
      effectiveDate: effectiveDate,
      production: productionDate,
      shipping: productionDate,
      arrival: deliveryDate,
      isAfterCutoff: isAfterCutoff
    };
  }

  function formatStickyDate(date) {
    const weekday = date.toLocaleDateString(
      'de-DE',
      {
        weekday: 'short'
      }
    );

    const day = String(
      date.getDate()
    ).padStart(2, '0');

    const month = String(
      date.getMonth() + 1
    ).padStart(2, '0');

    return `${weekday}, ${day}.${month}.`;
  }

  function render() {
    const data = calculateDates();

    const locale = 'de-DE';

    const longOpts = {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    };

    const els = {
      prod: container.querySelector(
        selectors.dateProduction
      ),

      ship: container.querySelector(
        selectors.dateShipping
      ),

      arr: container.querySelector(
        selectors.dateArrival
      ),

      final: container.querySelector(
        selectors.dateFinal
      ),

      count: container.querySelector(
        selectors.countdown
      ),

      stickyDeliveryDate: document.querySelector(
        selectors.stickyDeliveryDate
      )
    };

    if (els.prod) {
      els.prod.textContent =
        data.production.toLocaleDateString(
          locale,
          longOpts
        );
    }

    if (els.ship) {
      els.ship.textContent =
        data.shipping.toLocaleDateString(
          locale,
          longOpts
        );
    }

    if (els.arr) {
      els.arr.textContent =
        data.arrival.toLocaleDateString(
          locale,
          longOpts
        );
    }

    if (els.final) {
      els.final.textContent =
        data.arrival.toLocaleDateString(
          locale,
          longOpts
        );
    }

    if (els.stickyDeliveryDate) {
      els.stickyDeliveryDate.textContent =
        formatStickyDate(data.arrival);
    }

    if (els.count) {
      const dayName =
        data.effectiveDate.toLocaleDateString(
          locale,
          {
            weekday: 'long'
          }
        );

      const h = String(config.cutoffHour);

      const m = String(
        config.cutoffMin
      ).padStart(2, '0');

      els.count.textContent =
        `${config.textUntil} ${dayName}, ${h}:${m}`;
    }
  }

  render();

})();